import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class EasyPost_ds_get_ownerscarrierslookup_by_ownerId_carrierIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { ownerId: number, carrierId?: number }): 
  Promise<{ result: { OwnerId?: number, CarrierId?: number, AccountNumber?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerId)) {
      missingRequiredInParams.push('\'ownerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/EasyPost/datasources/ds_get_ownerscarrierslookup_by_ownerId_carrierId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { ownerId: number, carrierId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { OwnerId?: number, CarrierId?: number, AccountNumber?: string }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerId)) {
      missingRequiredInParams.push('\'ownerId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/EasyPost/datasources/ds_get_ownerscarrierslookup_by_ownerId_carrierId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { ownerId: number, carrierId?: number, $keys: { OwnerId?: number, CarrierId?: number }[] }): 
  Promise<{ result: { OwnerId?: number, CarrierId?: number, AccountNumber?: string }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.ownerId)) {
      missingRequiredInParams.push('\'ownerId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/EasyPost/datasources/ds_get_ownerscarrierslookup_by_ownerId_carrierId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      ownerId: number, carrierId?: number    }) {
        if(isNil(inParams.ownerId)) {
          return true; 
        }
      return false;
    }
}
